import client from './client';
import { QuotaUsage, QuotaType, QuotaRequest } from '../types';

export const quotaApi = {
  getMyQuota: () =>
    client.get<QuotaUsage>('/user/quota').then((r) => r.data),

  requestIncrease: (data: { quotaType: QuotaType; reason?: string; eventId?: string }) =>
    client.post<QuotaRequest>('/user/quota/request', data).then((r) => r.data),
};
